__turbopack_context__.v({
  "button-icon": "cRw3Zq_button-icon",
  "confirm": "cRw3Zq_confirm",
  "form-fields": "cRw3Zq_form-fields",
  "homepage-email": "cRw3Zq_homepage-email",
  "input-wrapper": "cRw3Zq_input-wrapper",
  "label": "cRw3Zq_label",
  "status": "cRw3Zq_status",
  "submit": "cRw3Zq_submit",
  "title": "cRw3Zq_title",
  "validation-error": "cRw3Zq_validation-error",
  "wrapper": "cRw3Zq_wrapper",
});
